<template>
  <div class="footerBody">
    <span class="returnTop" @click="goTop()"></span>
    <a-layout-footer>
      <!--<img class="fonterImage" src="../image/foot.png" />-->
      <div class="formData">
        <div>
          <img src="../image/emall.png" />
          <P>
            EMALL
          </P>
          <p><span></span></p>
          <p>service@minderwork.com</p>
        </div>
        <div>
          <img src="../image/call.png" />
          <P>
            CALL
          </P>
          <p><span></span></p>
          <p>0571-86375773 <br />15384007312</p>
          <p></p>
        </div>
        <div>
          <img src="../image/findce.png" />
          <P>
            FIND&nbsp;&nbsp;US
          </P>
          <p><span></span></p>
          <p>{{ $tc('lang.header.footer_address') }}</p>
        </div>
      </div>
      <div class="formBottom">{{ $tc('lang.MINDER_INSPECTION') }}</div>
      <div class="forGongShang" @click="goBack">
        <img class="chinaStyle" src="../image/China.png" />浙ICP备19025291
      </div>
    </a-layout-footer>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    goTop() {
      let timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
    goBack() {
      window.open('http://www.beian.miit.gov.cn');
    },
  },
};
</script>

<style lang="less">
.footerBody {
  height: 410px;
  padding: 0 10%;
  background-image: url('../image/foot.png');
  background-size: cover;
  z-index: 99999;
  position: relative;
  // .fonterImage {
  //   width: 100%;
  //   z-index: 200;
  // }
  .ant-layout-footer {
    background-color: transparent;
  }

  .formData {
    padding: 0 10%;
    margin-top: 70px;
    display: flex;
    border-bottom: 1px solid #b4b4b4;
    justify-content: space-around;
    > div {
      /*width: 30%;*/
      p {
        margin-bottom: 20px;
      }
      p:nth-child(2) {
        margin-top: 20px;
        color: #b4b4b4;
      }
      p:nth-child(4) {
        color: #b4b4b4;
      }
      p:nth-child(3) span {
        background-color: #00b7ef;
        width: 6px;
        height: 6px;
        display: inline-block;
        border-radius: 50%;
      }
    }
  }
  .formBottom {
    color: #ffffff;
    font-size: 20px;
    margin: 30px auto;
  }
  .forGongShang {
    color: #ffffff;
    font-size: 15px;
    cursor: pointer;
    margin: 0 auto;
    .chinaStyle {
      width: 25px;
    }
  }
  .returnTop {
    position: absolute;
    top: -20px;
    left: 50%;
    margin-left: -10px;
    width: 40px;
    height: 40px;
    background-image: url('../image/returnTop.png');
    background-size: 100% 100%;
    display: inline-block;
    /*margin: -10px auto;*/
  }
  @media all and (max-width: 1200px) {
    & {
      width: 1200px;
    }
  }
}
</style>
